/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '/',
    name: 'Home',
    view: 'gis/Index'
  },
  {
    path: '/login',
    name: 'Ingresar',
    view: 'auth/Login'
  },
  {
    path: '/dashboard',
    // Relative to /src/views
    view: 'Dashboard'
  },
  {
    path: '/user-profile',
    name: 'User Profile',
    view: 'UserProfile'
  },
  {
    path: '/table-list',
    name: 'Table List',
    view: 'TableList'
  },
  {
    path: '/typography',
    view: 'Typography'
  },
  {
    path: '/icons',
    view: 'Icons'
  },
  {
    path: '/maps',
    view: 'Maps'
  },
  {
    path: '/notifications',
    view: 'Notifications'
  },
  {
    path: '/upgrade',
    name: 'Upgrade to PRO',
    view: 'Upgrade'
  },
  {
    path: '/404',
    name: 'Not found',
    view: '404'
  },
//ADMINISTRACIÓN
  //Administracion del sitio
  {
    path: '/admin/menu',
    name: 'Menu',
    view: 'settings/Menu'
  },
  {
    path: '/admin/menu/create',
    name: 'Crear item de Menu',
    view: 'settings/MenuCreate'
  },
  {
    path: '/admin/menu/edit/:id',
    name: 'Editar item de Menu',
    view: 'settings/MenuEdit',
    props: true
  },
  {
    path: '/admin/databases',
    name: 'Base de datos',
    view: 'settings/Database',
    props: true
  },
  {
    path: '/admin/documentation/index',
    name: 'Documentación',
    view: 'settings/DocumentationIndex',
    props: true
  },
  {
    path: '/admin/documentation/form/:id?',
    name: 'Contenido',
    view: 'settings/DocumentationForm',
    props: true
  },

  //VARIABLES
  {
    path: '/admin/variables',
    name: 'Variables',
    view: 'variables/Variables'
  },
  {
    path: '/admin/variables/create',
    name: 'Crear Variables',
    view: 'variables/Create'
  },
  {
    path: '/admin/variables/edit/:id',
    name: 'Editar Variables',
    view: 'variables/Edit'
  },
  // APPEARS
  {
    path: '/admin/appears',
    name: 'Datos de Appears',
    view: 'variables/Appears'
  },
  //CALCULADORA
  {
    path: '/admin/calculator',
    name: 'Formulas',
    view: 'calculator/Calculator'
  },
  {
    path: '/admin/calculator/create',
    name: 'Creación de ecuaciones',
    view: 'calculator/Create'
  },
  {
    path: '/admin/calculator/edit/:id',
    name: 'Editar ecuaciones',
    view: 'calculator/Edit'
  },
  //DATOS
  {
    path: '/admin/data/raw',
    name: 'Datos brutos',
    view: 'dataraw/DataRaw'
  },
  {
    path: '/admin/data/proccess',
    name: 'Datos procesados',
    view: 'dataproccess/DataProccess'
  },
  {
    path: '/admin/data/sets',
    name: 'Sets de pruebas',
    view: 'datasets/DataSets'
  },
  //RUTINAS
  {
    path: '/admin/routine/download',
    name: 'Rutinas de descarga',
    view: 'routine/Downloads'
  },
  {
    path: '/admin/routine/proccess',
    name: 'Rutinas de procesamiento de datos',
    view: 'routine/Proccess'
  },
  {
    path: '/admin/routine/alerts',
    name: 'Rutinas de emisión de alertas',
    view: 'routine/Alerts'
  },
  // GEOREFERENCIA
  {
    path: '/admin/category',
    name: 'Categorias de recolección',
    view: 'points/Category'
  },
  {
    path: '/admin/points',
    name: 'Punto de georeferencia',
    view: 'points/Point'
  },
  // RESULTADOS
  {
    path: '/admin/results',
    name: 'Resultados',
    view: 'results/Index'
  },
  {
    path: '/admin/district',
    name: 'Localidad estudiada',
    view: 'points/Localities'
  },
  //USUARIOS
  {
    path: '/admin/users',
    name: 'Usuarios',
    view: 'users/User'
  },
  {
    path: '/admin/test',
    name: 'Pruebas',
    view: 'calculator/Test'
  },
  {
    path: '/admin/users/create',
    name: 'Editar Usuarios',
    view: 'users/Edit'
  },
  // DOCUMENTACIÓN Y MANUAL DE USO
  {
    path: '/help/index',
    name: 'Introducción',
    view: 'help/Introduction'
  },
  {
    path: '/gis',
    name: 'Gis',
    view: 'gis/Index'
  },
  {
    path: '/403/:id',
    name: '403',
    view: '403'
  }
  // API REFERENCE

]
